import { catchError, Observable, throwError } from 'rxjs';
import {
  HttpContextToken,
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { AlertService } from '@services';
import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';

export const IGNORE_ERROR = new HttpContextToken<boolean>(() => false);

@Injectable()
export class AuthTokenInterceptor implements HttpInterceptor {
  private notificationService = inject(AlertService);
  private router = inject(Router);

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      catchError((err) => {
        if (err instanceof HttpErrorResponse && !err?.error?.question) {
          if ((this.router.url === '/' || this.router.url === '/login') && (err.status === 400 || err.status === 401)) {
            return throwError(() => err);
          }
          if (!(err.url?.includes('login') && (err.status === 400 || err.status === 401))) {
            // Prevent showing the error if the request has ignoreError set to true
            const ignoreError = request.context.get(IGNORE_ERROR);
            if (!ignoreError) {
              this.notificationService.showError(err);
            }
          } else {
            this.router.navigateByUrl('login');
          }
        }
        return throwError(() => err);
      }),
    );
  }
}
